import React from 'react';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import FleetTopupView from '../../components/FleetTopupView';

FleetTopupScreen.propTypes = {};

function FleetTopupScreen(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid p-0">
                <FleetTopupView />
            </div>
        </KT01BaseLayout>
    );
}

export default FleetTopupScreen;
